import type moment from 'moment';
import { useEffect, useState } from 'react';

/**
 * Returns a `Date` instance that is refreshed at the specified interval,
 * to allow for pure initial rendering cycles. (I.e., avoiding the
 * `react-hooks/purity` ESLint complaint.)
 */
export function useNow(refreshInterval: moment.Duration): Date {
    const intervalMs = refreshInterval.asMilliseconds();
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);

    return now;
}
